module.exports = __webpack_public_path__ + "img/gareth-bale.1eabfab5.png";